/**************************************************
 * Nombre:       Formulario_Catalogo_Valores
 * Descripcion:
 *
 * Libreria:
 *
 * Tiempo:     1 Hr
 **************************************************/
import {Grid, Typography} from "@mui/material";
import IngresoTexto from "../../../Modulo_formularios/Componentes/IngresoTexto";
import {Height, Money, MoneyOff, Scale, TrendingFlat, ViewInAr} from "@mui/icons-material";
import IngresoDinero from "../../../Modulo_formularios/Componentes/IngresoDinero";

const Formulario_Catalogo_Valores = ({...props}) => {

    return (
        <form noValidate style={{width: '100%'}}>
            <Grid
                container
                justifyContent={'flex-start'}
                alignItems={'flex-start'}
                size={{xs: 12, sm: 12, md: 12}}
                spacing={2}
            >


                <Grid container size={{xs: 12, sm: 12, md: 12}}>
                    <IngresoTexto nombre={'Nombre del producto'}
                                  dato={'nombre'} {...props}
                                  editable={false}
                                  requerido={'El Nombre es requerido'}
                    />
                </Grid>

                <Grid container size={6}>
                    <IngresoDinero Icono={Money} nombre={'Valor'} dato={'valor'} {...props}
                    />
                </Grid>

                <Grid container size={6}>
                    <IngresoDinero Icono={MoneyOff} nombre={'Valor Antes'} dato={'valorAntes'} {...props}
                    />
                </Grid>


                <Grid container size={{xs: 12, sm: 12, md: 12}} sx={{justifyContent: 'flex-start'}}>
                    <Typography>Datos para envio</Typography>
                </Grid>

                <Grid container size={6}>
                    <IngresoTexto type={'number'} Icono={Height} nombre={'Alto (cm)'} dato={'alto'} {...props}
                    />
                </Grid>

                <Grid container size={6}>
                    <IngresoTexto type={'number'} Icono={TrendingFlat} nombre={'Ancho (cm)'} dato={'ancho'} {...props}
                    />
                </Grid>

                <Grid container size={6}>
                    <IngresoTexto type={'number'} Icono={ViewInAr} nombre={'Fondo (cm)'} dato={'fondo'} {...props}
                    />
                </Grid>

                <Grid container size={6}>
                    <IngresoTexto type={'number'} Icono={Scale} nombre={'Peso (gramos)'} dato={'peso'} {...props}
                    />
                </Grid>


            </Grid>

        </form>

    )

}
export default Formulario_Catalogo_Valores